module.exports = __webpack_public_path__ + "static/media/noun_landscape_2069732.e1e91e6c.svg";